import { Link } from 'react-router-dom';

interface ClusterCard {
  title: string;
  description: string;
  to?: string;
  available: boolean;
}

const clusterCards: ClusterCard[] = [
  {
    title: 'Развитие персонала',
    description: 'Хаб кластера: системный подход к развитию сотрудников и компетенций, от диагностики до сопровождения.',
    to: '/razvitie-personala',
    available: true,
  },
  {
    title: 'Оценка и развитие сотрудников',
    description: 'Как определить компетенции, потенциал и зоны развития — основа для отбора кандидатов в кадровый резерв.',
    to: '/razvitie-personala/otsenka-i-razvitie-sotrudnikov',
    available: true,
  },
  {
    title: 'Индивидуальный план развития сотрудников',
    description: 'Как превратить результаты оценки в конкретный план развития конкретного резервиста.',
    to: '/razvitie-personala/individualnyy-plan-razvitiya-sotrudnikov',
    available: true,
  },
  {
    title: 'Наставничество и развитие сотрудников',
    description: 'Передача опыта и развитие навыков непосредственно в рабочем процессе.',
    to: '/menedzhment-i-liderstvo/nastavnichestvo-i-razvitie-sotrudnikov',
    available: true,
  },
  {
    title: 'Корпоративная академия',
    description: 'Как построить системное обучение и развитие сотрудников внутри компании.',
    to: '/enciklopediya-korporativnogo-obucheniya/korporativnaya-akademiya',
    available: true,
  },
  {
    title: 'Обучение персонала',
    description: 'Как выстроить обучение сотрудников, связанное с задачами бизнеса.',
    to: '/enciklopediya-korporativnogo-obucheniya/obuchenie-personala',
    available: true,
  },
];

export default function ClusterNavigation() {
  return (
    <section className="py-16 md:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Развитие персонала
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-12 leading-relaxed">
          Кадровый резерв — часть системы развития сотрудников. Он связывает оценку, отбор, индивидуальные планы развития, обучение, наставничество и практику в единый процесс подготовки людей к будущим ролям. Ниже — направления кластера, которые уже доступны на сайте.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {clusterCards.map((card, i) => (
            <div key={i} className={`bg-white rounded-xl border ${card.available ? 'border-gray-200 hover:border-teal-300 hover:shadow-lg' : 'border-gray-200/70'} transition-all p-5 md:p-6 flex flex-col`}>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{card.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 flex-grow">{card.description}</p>
              {card.available && card.to ? (
                <Link to={card.to} className="inline-flex items-center gap-1.5 text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap mt-auto">
                  Подробнее
                  <i className="ri-arrow-right-line"></i>
                </Link>
              ) : (
                <span className="inline-flex items-center gap-1.5 text-sm text-gray-400 mt-auto">
                  Скоро
                  <i className="ri-time-line"></i>
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}